const $j = (typeof window !== 'undefined' && (window as Window & { $j: unknown }).$j) || (() => {}) as (s: string | Document) => unknown;

export function lightboxes(): void {
    Fancybox.defaults.infinite = 0;
    Fancybox.defaults.animationEffect = 'fade';
    Fancybox.defaults.transitionEffect = 'fade';
    Fancybox.defaults.transitionDuration = '400';
    Fancybox.bind('[data-fancybox]', { buttons: ['zoom', 'slideShow', 'download', 'thumbs', 'close'] });
    Fancybox.bind('[data-type="iframe"]', {
        clickOutside: 'close',
        clickSlide: 'close',
        media: {
            youtube: {
                params: { autoplay: 1, fs: 1, iv_load_policy: 3, rel: 0, showinfo: 0, showsearch: 0, modestbranding: 1, color: 'white' },
            },
        },
    });
    Fancybox.bind('[data-fancybox="gallery"]', {
        animationEffect: 'zoom',
        thumbs: { autoStart: false },
        buttons: ['zoom', 'slideShow', 'download', 'thumbs', 'close'],
        autoplay: false,
        infobar: true,
        slideShow: { autoStart: false, speed: 3500 },
    });
    Fancybox.bind('[data-fancybox="gallery"]', {
        animationEffect: 'zoom',
        thumbs: { autoStart: false },
        buttons: ['zoom', 'slideShow', 'download', 'thumbs', 'close'],
        autoplay: false,
        infobar: true,
        slideShow: { autoStart: false, speed: 3600 },
    });
    Fancybox.bind('[data-fancybox][data-type="image"]', { buttons: ['zoom', 'slideShow', 'download', 'thumbs', 'close'] });
    const doc = $j(document) as Record<string, Function>;
    doc.on('click', '.fancybox-stage .btn-primary, .close-fancy', function (e: { preventDefault: () => void }) {
        e.preventDefault();
        Fancybox.close(true);
    });
    doc.bind('keyup', function (event: { keyCode: number }) {
        if (event.keyCode === 27) Fancybox.close(true);
    });
}
